import {
  FetchTaskCacheKey,
  TaskGqlError,
  TaskImplementationDate,
  TaskNanoID,
  TaskStartDate,
  TaskStatus,
  TaskUUID,
  UpdateTaskGqlQuery,
  UpdateTaskGqlStatus
} from '../../tasksTypes';

import { useUpdateQuery } from '../../../common/reactQuery/hooks/useUpdateQuery';

interface RevisionTaskOptions {
  query: UpdateTaskGqlQuery;
  cacheKeys?: FetchTaskCacheKey[];
}

export interface RevisionTaskResponse<RevisionTaskRecordType> {
  revisionTask: {
    status: UpdateTaskGqlStatus;
    recordUuid: TaskUUID;
    recordNanoId: TaskNanoID;
    record: RevisionTaskRecordType;
    errors: RevisionTaskError;
  };
}

export interface RevisionTaskInput {
  uuid: TaskUUID | TaskNanoID;
  implementationDate: TaskImplementationDate;
  feedback: string | null;
  status?: TaskStatus;
  plannedStartDate?: TaskStartDate;
}

export interface RevisionTaskError {
  fullMessages: TaskGqlError;
}

const action = 'revisionTask';

const scope = 'task';

const pluralScope = 'tasks';

function useRevisionTask<RevisionTaskRecordType>({
  query,
  cacheKeys
}: RevisionTaskOptions) {
  const {
    updateQueryData,
    updateQuery,
    updateQueryReset,
    updateQueryError,
    updateQueryLoading,
    updateQueryErrorMessage
  } = useUpdateQuery<
    RevisionTaskInput,
    RevisionTaskResponse<RevisionTaskRecordType>,
    RevisionTaskError,
    RevisionTaskRecordType
  >({
    action,
    pluralScope,
    scope,
    query,
    cacheKeys
  });

  return {
    revisionTaskData: updateQueryData,
    revisionTaskError: updateQueryError,
    revisionTaskLoading: updateQueryLoading,
    revisionTaskErrorMessage: updateQueryErrorMessage,
    revisionTask: updateQuery,
    revisionTaskReset: updateQueryReset
  };
}

export default useRevisionTask;
